<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="isOsStlye.maxWidth"
    @keydown.esc="closeOrganization"
  >
    <!-- layer_popWrap -->
    <v-card id="tbOrganizationChart" >
      <div class="dialog-container">
        <div class="dialog-header" style="height: 50px;">
          <h3 class="header-title">조직도</h3>
        </div>
        <div class="dataTable" style="height: 100%; padding: 5px 0;">
          <div class="popup_tel_wrap" style="display: flex; flex-direction: column; overflow: hidden;">
            <div class="orga-search_area">
              <input
                type="text"
                ref="searchUser"
                class="search_input"
                style="padding-left: 1%; width: 40%; height: 40px; font-size: 10pt; border-radius: 5px; float: left; margin-bottom: 5px;"
                placeholder="검색할 내용을 입력해주세요"
                v-on:keyup.enter="searchAttendee()"
                v-model="searchText"
              />
              <button
                class="orga-searchBtn"
                :class="{ search_active: searchActive }"
                @click="searchAttendee()"
                style="margin-left: 10px;"
              >
                검색
              </button>
            </div>
            <div
              class="orga-container"
              style="display: flex; flex-direction: row; justify-content: start; height: 250px"
            >
              <div class="orga-step1">
                <v-treeview
                  class="organization-list"
                  v-model="attendeeTree"
                  :load-children="fetchUsers"
                  :active.sync="active"
                  :items="group"
                  :filter="filter"
                  :open.sync="open"
                  item-key="_id"
                  :item-text="
                    $store.state.locale === 'en'
                      ? 'displayNameEn'
                      : $store.state.locale === 'zn'
                      ? 'displayNameZh'
                      : 'displayName'
                  "
                  active-class="primary--text"
                  open-on-click
                  transition
                  return-object
                  activatable
                >
                  <!--                
                :items="group"
                activatable
                item-key="name" -->

                  <template slot="label" slot-scope="{ item }">
                    <div
                      class="organization-list-item"
                      @click="selectedNode(item)"
                    >
                      {{ item.displayName }}
                    </div>
                  </template>
                </v-treeview>
              </div>
              <!-- //list member_02 -->
              <div class="orga-step2">
                <span class="list_title">조회 목록</span>
                <div class="tb-header">
                  <div style="width:10%;">
                    <input
                      type="checkbox"
                      v-bind:class="{ active: isActive }"
                      v-model="allSelected"
                      id="all-checkbox"
                    />
                  </div>
                  <div style="width:20%;">이름</div>
                  <div style="width:30%;">직급</div>
                  <div style="width:40%;">부서</div>
                </div>
                <div style="overflow: auto; height: 230px;">
                <table class="member_list" cellpadding="0" cellspacing="0">
                  <caption>
                    이 표는 구성되어 있습니다.
                  </caption>
                  <colgroup>
                    <col style="width:10%;" />
                    <col style="width:20%;" />
                    <col style="width:30%;" />
                    <col style="width:40%;" />
                  </colgroup>
                  <tbody>
                    <tr
                      class="con"
                      v-for="member in groupMembers"
                      :key="member._id"
                    >
                      <td>
                        <div class="member_ck">
                          <input
                            type="checkbox"
                            v-bind:class="{ active: isActive }"
                            v-model="checkedMembers"
                            :id="member._id"
                            v-bind:value="member"
                          />
                          <label v-bind:for="member._id" v-bind:id="member._id">
                            <span></span>
                          </label>
                        </div>
                      </td>
                      <td>
                        <span class="">{{ member.name }}</span>
                      </td>
                      <td>
                        <span class=""
                          >{{
                            member.DUTY_NM === "팀장"
                              ? member.DUTY_NM
                              : member.positionName
                          }}
                        </span>
                      </td>
                      <td>
                        <span class="">{{ member.DEPT_NM }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
              <!-- <div>
                <button @click="addList" class="organization_add_btn">
                  추가
                </button>
              </div> -->
            </div>
            <!-- <button class="add-orga" @click="addList">추가</button> -->
            <!-- <div class="orga-step3">
              <div
                class="list_title"
                style="border-bottom: 1px solid #dddddd; padding-bottom: 10px;"
              >
                선택 목록
              </div>
              <div class="orga-selected-member-wrap">
                <div
                  class="orga-selected-member"
                  v-for="member in addedList"
                  :key="member._id"
                >
                  <div
                    style="display: flex; flex-direction: row; align-items: center;"
                  >
                    <img
                      style="width: 18px; height: 18px; cursor: pointer"
                      src="../../../src/images/button/btnClose.png"
                      :label="member.name"
                      v-bind:value="member"
                      @click="fucDeleteMembers(member)"
                    />
                    <div
                      style="display: flex; flex-direction: column; margin-left: 8px;"
                    >
                      <div style="display: flex; flex-direction: row;">
                        <div style="color: #333333; font-weight: bold;">
                          {{ member.name }}
                        </div>
                        <div
                          style="color: #666666; margin-left: 6px; font-size: 13px;"
                        >
                          {{ member.positionName }}
                        </div>
                      </div>
                      <div style="color: #666666;">{{ member.DEPT_NM }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="orga-step3">
                <span class="list_title">선택 목록</span>
                <table class="member_list" cellpadding="0" cellspacing="0">
                  <caption>
                    이 표는 구성되어 있습니다.
                  </caption>
                  <colgroup>
                    <col style="width:20%;" />
                    <col style="width:30%;" />
                    <col style="width:40%;" />
                    <col style="width:10%;" />
                  </colgroup>
                  <tbody>
                    <tr class="top-tr line">
                      <td>
                        <span class="">이름</span>
                      </td>
                      <td>
                        <span class="">직급</span>
                      </td>
                      <td>
                        <span class="">부서</span>
                      </td>
                      <td>
                        <span class=""></span>
                      </td>
                    </tr>
                    <tr
                      class="con"
                      v-for="member in addedList"
                      :key="member._id"
                    >
                      <td>
                        <span class="">{{ member.name }}</span>
                      </td>
                      <td>
                        <span class="">{{ member.positionName }} </span>
                      </td>
                      <td>
                        <span class="">{{ member.DEPT_NM }}</span>
                      </td>
                      <td>
                        <img
                          style="width: 13px; cursor: pointer"
                          src="../../../src/images/button/btnClose.png"
                          :label="member.name"
                          v-bind:value="member"
                          @click="fucDeleteMembers(member)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            <!-- //.list_on -->
          </div>
          <!-- // .popup_tel_wrap -->
        </div>

        <!-- 
        <div class="popup_tel_wrap">
          <div class="member_warp">
            <div class="searchbox">
              <div class="search_top inblk">
                  <input type="text" 
                        class="search_input" 
                        style="padding-left: 1%; width: 22%; height: 40px; font-size: 10pt; border-radius: 5px; float: left; margin-bottom: 15px;" 
                        placeholder="검색할 내용을 입력해주세요" 
                        v-model="searchText">
                  <button class="btn type3 orga-search-btn" @click="searchAttendee()">
                      검색
                  </button>
              </div>
            </div>
            <div class="seltabcontent">
              <div class="selta_l mCustomScrollbar">
                <v-treeview
                  class="organization-list"
                  :items="group"
                  activatable
                  item-key="name"
                >
                <template slot="label" slot-scope="{ item }">
                  <div class="organization-list-item" @click="openTeamMember(item)">{{ item.name }}</div>
                </template>
                </v-treeview>
              </div>

              <div class="seltab_r p_ad fl">
                <div class="tbw_top_left grid-title">
                  <span>선택하신 조직목록입니다.</span>
                </div>
                <div class="all-select-wrap">
                  <div class="floatLeft grid2-selectbox">
                    <label class="all-container-checkbox">
                      <input type="checkbox" @click="selectAll" v-model="allSelected">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="orga-header-title floatLeft" id="orgaTitleName">이름</div>
                  <div class="orga-header-title floatLeft" id="orgaTitleGrade">직급</div>
                  <div class="orga-header-title floatLeft" id="orgaTitleDept">부서</div>
                </div>
                <div class="members-wrap">
                  <div class="member-item" v-for="member in groupMembers" :key="member._id"> 
                    <div class="profile-contents">
                      <label v-bind:for="member.name" v-bind:id="'user'+member._id" class="container-checkbox">
                        <input type="checkbox" v-bind:class="{ active: isActive }" v-model="checkedMembers" :label="member.name" v-bind:value="member">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div class="profile-name floatLeft">
                      <span>{{ member.name }}</span>
                    </div>
                    <div class="profile-grade floatLeft">
                      {{ member.grade }} 
                    </div>
                    <div class="profile-dept floatLeft">
                      {{ member.deptName }}
                    </div>
                  </div>
                </div>
              </div> 
              <div class="seltab">
                <a class="btn type3" @click="addList" style="display: inline-block; width: 60px; height: 30px; line-height: 30px; padding :0;">추가 ></a>
              </div>

              <div class="seltab_r p_ad p_adc">
                <div class="tbw_top_left grid-title">
                  <span>선택하신 목록입니다.</span>
                </div>
                <div class="all-select-wrap">
                  <div class="selec-header-title floatLeft" id="selectTitleName">이름</div>
                  <div class="selec-header-title floatLeft" id="selectTitleGrade">직급</div>
                  <div class="selec-header-title floatLeft" id="selectTitleDept">부서</div>
                  <div class="selec-header-title floatLeft" id="selectTitleDel">삭제</div>
                </div>

                <div class="member-selected-wrap">
                  <div class="member-item" v-for="member in addedList" v-bind:key="member._id">
                    <div class="profile-name floatLeft">
                      <span>{{member.name}}</span>
                    </div>
                    <div class="profile-grade floatLeft">
                        {{member.grade}} 
                    </div>
                    <div class="profile-dept floatLeft">
                      {{ member.deptName }}

                    </div>
                    <div class="profile-del">
                      <img src="../../assets/closeBtn.png" :label="member.name" v-bind:value="member" @click="fucDeleteMembers(member)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        -->

        <div class="btnArea">
          <button class="close-btn" @click="closeOrganization()">
            닫기
          </button>
          <button class="invite-btn" @click="createSelectedList">완료</button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";
import Vuetify from "vuetify";
import axios from "axios";

export default {
  props: ["dialog", "closeDialog"],
  data() {
    return {
      isOsStlye: {
        maxWidth: "720px",
        marginLeft: 0,
      },
      corp: "(주)ECS텔레콤",
      search: "" /* 검색 */,
      allSelected: false /* 전체 체크박스 */,
      groupMembers: [],
      checkedMembers: [] /* 체크박스 유저 정보 */,
      addedList: [] /* 선택 목록 */,
      deleteMembers: [] /* 삭제 유저 정보 */,
      isActive: true,
      selectedGroup: [] /* 선택된 그룹 */,
      group: [] /* Tree Item */,
      teamMember: [],
      searchText: null,
      attendeeTree: [],
      active: [],
      open: [],
      myCompanyOrgData: [],
      caseSensitive: false,
      searchActive: false,
    };
  },
  computed: {
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  watch: {
    dialog: {
      async handler(val) {
        this.initOrg();
        // true값일 경우
        console.log(`handler : `, val);
        if (val) {
          await this.getOrganizationTree(undefined, true);
          let attendeeList = [];
          // 화면 개편작업하면서 주석처리함
          // attendeeList = this.meetingInfo.attendees;

          const orgUsers = attendeeList
            .filter(x => x.email !== x.username)
            .map(x => x.email);
          const emailUsers = attendeeList
            .filter(x => x.email === x.username)
            .map(x => {
              return {
                username: x.username,
                title: this.$t(
                  "page.meeting-reserve.organization.external-participants"
                ),
                department: this.$t(
                  "page.meeting-reserve.organization.external-participants"
                ),
              };
            });
          if (orgUsers.length > 0) {
            let orgUserFullData = (
              await this.$http.get(`/api/v1/organizations`, {
                params: { emails: orgUsers },
              })
            ).data;
            this.addedList.push(...orgUserFullData);
          }
          this.addedList.push(...emailUsers);
        }
      },
    },
    allSelected(val) {
      if (val === true) {
        let groupMembers = this.groupMembers;
        for (let member = 0; member < groupMembers.length; member++) {
          this.checkedMembers.push(groupMembers[member]);
        }
        this.allSelected = true;
      } else {
        this.allSelected = false;
        // this.checkedMembers = [];
      }
    },
    searchText: function(newVal) {
      let search = newVal;
      let searchLength = 4;
      const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/;
      if (check.test(search)) {
        searchLength = 2;
      }
      if (search === null || search === "" || search.length < searchLength) {
        // console.log('people clear');
        this.organization = [];
        return;
      } else {
        console.log(search.length);
      }
      console.log(search.trim());
    },
  },
  mounted() {
    this.initOrg();
  },
  methods: {
    async initOrg() {
      let os = Util.getOS();
      if (os.indexOf("window") !== -1) {
        this.isOsStlye.maxWidth = "1300px";
      }
      // Get Department Tree
      // let params = { siteName: this.$store.state.user.siteName };
      // await this.$http.get('/api/v1/organizations/tree/detp', { params: params }).then(response => {
      //   this.group = response.data;
      // }).catch(error => {
      //   console.log(error.response.data.error);
      // });
      this.groupMembers = [];
      this.addedList = [];
    },
    async searchAttendee() {
      // Get Users In Dept
      this.allSelected = false;
      //this.checkedMembers = [];
      let search = this.searchText;
      let searchLength = 4;
      const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/;
      if (check.test(search)) {
        searchLength = 2;
      }
      if (search === null || search === "" || search.length < searchLength) {
        alert("검색할 내용은 최소 2글자 이상 입력해주세요");
        this.organization = [];
        return;
      }

      if (!this.searchText || this.searchText === "") {
        this.groupMembers = [];
      }

      let params = {
        search: this.searchText,
      };
      this.groupMembers = [];
      await this.$http
        .get(`/api/v1/organizations/filtered`, { params: params })
        .then(response => {
          let responseData = response.data;
          console.log(responseData);
          this.groupMembers = responseData.map(d => {
            d["grade"] = d.title;
            return d;
          });
        })
        .catch(error => {
          console.log(error.response.data.error);
        });
    },
    async fetchUsers(item) {
      console.log(`fetchUsers`, item);
      await this.getOrganizationTree(item, false);
    },
    async getOrganizationTree(selectedItem, isInit) {
      this.search = "";
      let params = {
        isInit: isInit,
      };
      if (isInit) {
        this.group = [];
        this.open = [1];
      }
      if (selectedItem !== undefined) {
        params["DEPT_CD"] = selectedItem.deptCode;
      } else {
        let email = '';
        if (this.$store.state.user) {
          email = this.$store.state.user.email;
        } else {
          email = 'kmeeting_reserv@krx.co.kr'; 
        }
        
        console.log(`email : `,email);
        let userCompanyInfo = (
          await this.$http.get("/api/v1/organizations", {
            params: { emails: [email] },
          })
        ).data;
        if (userCompanyInfo.length > 0) {
          params["DEPT_CD"] = userCompanyInfo.deptCode;
        }
      }
      let myCompanyInfo = await this.getMyCompanyInfo();
      console.log(`myCompanyInfo1111`, myCompanyInfo);
      if (myCompanyInfo) {
        params["rootOrgUnitId"] =
          myCompanyInfo.rootOrgUnitId !== null &&
          myCompanyInfo.rootOrgUnitId !== undefined
            ? myCompanyInfo.rootOrgUnitId
            : -1;
      } else {
        params["rootOrgUnitId"] = -1;
      }

      await this.$http
        .get("/api/v1/organizations/trees/dynamic", { params: params })
        .then(response => {
          // Dynamic Version
          if (isInit) {
            this.group = response.data;
          } else {
            selectedItem.children.push(...response.data);
          }
          this.openOrganizationFolder(
            myCompanyInfo.rootOrgUnitId,
            myCompanyInfo.DEPT_CD
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getMyCompanyInfo() {
      let email = '';
      if (this.$store.state.user) {
        email = this.$store.state.user.email;
      } else {
        email = 'kmeeting_reserv@krx.co.kr'; 
      }
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/api/v1/organizations`, {
            params: {
              emails: [email],
            },
          })
          .then(response => {
            let myCompanyInfo = response.data;
            console.log(`myCompanyInfo`, myCompanyInfo);
            if (myCompanyInfo.length > 0) {
              resolve(myCompanyInfo[0]);
            } else {
              resolve(undefined);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    openOrganizationFolder(rootOrgUnitId, deptCode) {
      console.log(`rootOrgUnitId :::::::::: `, rootOrgUnitId);
      let isMyOrgFlag = true;
      let findId = deptCode;
      while (rootOrgUnitId !== findId) {
        let getIndex = function(myCompanyOrgData, findId) {
          return myCompanyOrgData.findIndex(x => x.deptCode === findId);
        };
        let findIndex = getIndex(this.myCompanyOrgData, findId);
        if (isMyOrgFlag) {
          this.active.push(this.myCompanyOrgData[findIndex]);
          this.selectedNode(this.myCompanyOrgData[findIndex]);
          isMyOrgFlag = false;
        }
        if (findIndex > 0) {
          findId = this.myCompanyOrgData[findIndex].UP_DEPT_CD;
          this.open.push(this.myCompanyOrgData[findIndex]);
        } else {
          break;
        }
      }
      let findIndex = this.myCompanyOrgData.findIndex(
        x => x.DEPT_CD === rootOrgUnitId
      );
      this.open.push(this.myCompanyOrgData[findIndex]);
    },
    async selectedNode(selectedItem) {
      if (selectedItem) {
        this.selectedTreeNode = selectedItem;
        console.log(`selectedItem : `, selectedItem);
        this.search = "";
        const deptUnitId = selectedItem.deptCode;
        const deptUsers = (
          await this.$http.get(`/api/v1/users/dept/${deptUnitId}`)
        ).data;
        this.groupMembers = deptUsers;
      }
    },
    async openTeamMember(team) {
      // Get Users In Dept
      console.log(team);
      let params = {
        siteName: this.$store.state.user.siteName,
        deptCode: team.deptCode,
      };
      this.groupMembers = [];
      await this.$http
        .get(`/api/v1/organizations`, { params: params })
        .then(response => {
          let responseData = response.data;
          this.groupMembers = responseData.map(d => {
            d["grade"] = d.title;
            return d;
          });
        })
        .catch(error => {
          console.log(error.response.data.error);
        });
      // await this.$http.get(`/api/v1/users/`).then((response) => {

      // }).catch(error => {
      //   console.log(error);
      // });

      // /* 팀원들 조회 */
      // /* 대규모 서비스가 아닐 경우 */
      // let selectedGroupMember = [];
      // let teamMember = this.teamMember;

      // let mainGroup = team.mainGroup;
      // let subGroup1 = team.subGroup1;
      // let subGroup2 = team.subGroup2;

      // /* 전체선택 */
      // if (typeof team.corp !== 'undefined') {
      //   for (let i = 0; i < teamMember.length; i++) {
      //     selectedGroupMember.push(teamMember[i]);
      //   }
      // }

      // if (typeof team.subGroup1 !== 'undefined') { /* subGroup1 있을 경우 */
      //   if (typeof team.subGroup2 !== 'undefined') { /* subGroup2가 있을 경우 */
      //     /* subGroup3이 필요한 경우 아래로 추가하면 된다. 추후 리팩토링 작업하도록 하자. */
      //     for (let i in teamMember) {
      //       if (teamMember[i].subGroup2 === subGroup2) {
      //         selectedGroupMember.push(teamMember[i]);
      //       }
      //     }
      //   } else { /* subGroup2가 없을 경우 */
      //     for (let i in teamMember) {
      //       if (teamMember[i].subGroup1 === subGroup1) {
      //         selectedGroupMember.push(teamMember[i]);
      //       }
      //     }
      //   }
      // } else { /* mainGroup을 클릭한 경우 */
      //   for (let i in teamMember) {
      //     if (teamMember[i].mainGroup === mainGroup) { /* 메인 그룹이 같을 경우 */
      //       selectedGroupMember.push(teamMember[i]);
      //     }
      //   }
      // }

      // this.selectedGroup = team;
      // this.groupMembers = selectedGroupMember; /* groupMember객체 내 선택된 GroupMember 담기 */
      // this.checkedMembers = []; /* 체크되어 있는 맴버 초기화 */
    },
    addList() {
      this.allSelected = false;

      let teamMember = this.teamMember;
      let checkedMember = this.checkedMembers;
      let groupMember = this.groupMembers;

      this.isActive = false;
      /* 전체 그룹에서 삭제 - 선택되어 있으면 다음에 선택 못하도록 처리 */
      for (let i = teamMember.length - 1; i >= 0; i--) {
        for (let j = 0; j < checkedMember.length; j++) {
          if (teamMember[i]._id === checkedMember[j]._id) {
            this.teamMember.splice(i, 1);
            break;
          }
        }
      }

      /* 선택 그룹에서 삭제 - 팀내에서 재선택을 못하도록 처리하기 위해 */
      for (let i = groupMember.length - 1; i >= 0; i--) {
        for (let j = 0; j < checkedMember.length; j++) {
          if (groupMember[i]._id === checkedMember[j]._id) {
            groupMember.splice(i, 1);
            break;
          }
        }
      }

      if (this.addedList.length === 0) {
        this.checkedMembers.map(x => this.addedList.push(x));
      } else {
        let addedEmail = this.addedList.map(at => at.email);
        this.addedList = this.addedList.concat(
          checkedMember.filter(a => !addedEmail.includes(a.email))
        );
      }

      this.checkedMembers = []; /* 선택된 맴버 초기화 */
    },
    fucDeleteMembers(member) {
      /* 선택 목록 > 삭제버튼 */
      let teamMember = this.teamMember;
      let addedList = this.addedList;
      console.log(teamMember);
      console.log(member);
      if (teamMember.length === 0) {
        this.teamMember.push(member);
      } else {
        for (let i in teamMember) {
          if (
            teamMember[i]._id !== member._id &&
            teamMember[i].name !== member.name
          ) {
            /* 팀내 아이디, 이름과 삭제를 클릭한 아이디, 이름이 같은 목록에 없으면 member 객체추가 */
            if (parseInt(i, 10) + 1 === teamMember.length) {
              console.log("# pushed");
              this.teamMember.push(member);
            }
          } else {
            console.log(member);
          }
        }
      }

      for (let i in addedList) {
        /* 선택 목록에서 삭제해주는 동작 */
        if (
          addedList[i]._id === member._id &&
          addedList[i].name === member.name
        ) {
          addedList.splice(i, 1);
        }
      }
      this.groupMembers.push(member);
    },
    deleteAll() {
      /* 전체 삭제 */
      let selectedGroup = this.selectedGroup;
      let addedList = this.addedList;

      for (let i = 0; i < addedList.length; i++) {
        this.teamMember.push(addedList[i]);
      }

      /* 초기화 */
      this.openTeamMember(selectedGroup);
      this.addedList = [];
    },
    selectAll() {
      let groupMembers = this.groupMembers;

      if (!this.allSelected) {
        for (let member = 0; member < groupMembers.length; member++) {
          this.checkedMembers.push(groupMembers[member]);
        }
      } else {
        this.checkedMembers = [];
      }
    },
    filteredList() {
      this.groupMembers = []; /* groupMembers 초기화 */
      /* search폼에 입력값으로 filter */
      return this.teamMember.filter(teamMember => {
        if (
          this.search !== "" &&
          teamMember.name.includes(this.search) === true
        ) {
          this.groupMembers.push(teamMember);
        }
        return "";
      });
    },
    createSelectedList() {
      this.addList();
      this.$emit("createSelectedList", this.addedList);
      // 초기화
      this.groupMembers = [];
      this.checkedMembers = [];
      this.addedList = [];
      this.selectedGroup = [];
      this.closeDialog();
      this.searchText = null;
    },
    closeOrganization() {
      this.searchText = null;
      this.closeDialog();
    },
  },
};
</script>
<style scoped>
.dialog-container {
  width: 100%;
}
.dialog-header {
  width: 100%;
}

.list_title {
  color: #666;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.52px;
}

.top-tr {
  background-color: #f9f9f9;
  color: #333;
}
.orga-searchBtn {
  width: 54px;
  height: 37px;
  background-color: #f2f2f2;
  color: #333;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.24px;
  border-radius: 4px;
}
#organizationChart .bt_wrap {
  width: 1300px;
}
.floatLeft {
  float: left;
}
/* 조직 스크롤 바 */
.organization-wrap::-webkit-scrollbar {
  width: 6px;
}
.organization-wrap::-webkit-scrollbar-track {
  background-color: transparent;
}
.organization-wrap::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.organization-wrap::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
/* 조직도 스크롤 바 */
.members-wrap::-webkit-scrollbar {
  width: 6px;
}
.members-wrap::-webkit-scrollbar-track {
  background-color: transparent;
}
.members-wrap::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.members-wrap::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
/* 선택목록 스크롤 바 */
.member-selected-wrap::-webkit-scrollbar {
  width: 6px;
}
.member-selected-wrap::-webkit-scrollbar-track {
  background-color: transparent;
}
.member-selected-wrap::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.member-selected-wrap::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}

.pop_top {
  padding-top: 10px;
  font-weight: 600;
}

.search-bar {
  width: 18%;
  height: 44px;
  font-size: 16px;
  letter-spacing: 0px;
  color: #000;
  border: 1px solid #e2e2e2;
  padding: 0px 20px;
  margin-left: 1%;
}

.organization-grid {
  float: left;
  width: 380px;
  border: 1px solid #e2e2e2;
  height: 95%;
}
/* 1번 그리드 */
#orgaGrid1 {
  width: 18%;
  margin: 1% 0.5% 0 1%;
}
/* 2번 그리드 */
#orgaGrid2 {
  width: 34%;
  margin: 1% 0.5% 0 1%;
}
/* 3번 그리드 */
#orgaGrid3 {
  width: 8%;
  margin: 1% 0.5% 0 1%;
}
#orgaGrid4 {
  width: 34%;
  margin: 1% 0.5% 0 1%;
}
.deleteMember {
  background: rgba(147, 206, 222, 1);
  cursor: pointer;
  margin-left: 20px;
}

.select-btn-wrap {
  float: left;
}

.select-btn-wrap > button {
  width: 30px;
  height: 30px;
  color: white;
  border-radius: 10px;
  margin-top: 230px;
  /* background-image: linear-gradient(to right, #e52d27 0%, #b31217 51%, #e52d27 100%); */
}
.select-btn-wrap > button:hover {
  background-position: right center;
}

.organization-list-item {
  cursor: pointer;
  font-size: 13px;
  color: #464646;
}

/* GRID2 */
.all-select-wrap {
  width: 96%;
  margin-left: 2%;
  height: 33px;
  line-height: 33px;
  text-align: center;
  border-top: 2px solid #fa4242;
  border-bottom: 1px solid #fa4242;
}

.orga-header-title {
  font-weight: 500;
}

/* GRID2 > 헤더 타이틀 */
.grid2-selectbox {
  width: 12%;
}
#orgaTitleName {
  width: 22%;
}
#orgaTitleGrade {
  width: 22%;
}
#orgaTitleDept {
  width: 42%;
}

.profile-contents {
  float: left;
  width: 12%;
  margin-top: 5px;
}
.profile-name {
  width: 22%;
  text-align: center;
  line-height: 33px;
  font-size: 11pt;
  font-weight: 500;
  position: relative;
}
.profile-grade {
  width: 22%;
  line-height: 33px;
  text-align: center;
  font-weight: 500;
}

.profile-dept {
  width: 44%;
  line-height: 33px;
  text-align: center;
  font-weight: 500;
}

.profile-del {
  float: left;
  width: 10%;
  text-align: center;
  line-height: 33px;
}

.profile-del img {
  width: 13px;
  cursor: pointer;
}

.profile-img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 70%;
  border: 1px solid #d6d6d6;
  float: left;
  margin-left: 10px;
  margin-top: 10px;
  position: absolute;
  left: 10px;
}

/* checkbox css */
.profile-contents > label {
  font-size: 13pt;
  font-weight: bold;
}

.profile-contents > .container-checkbox {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  margin-right: 10px;
  font-size: 17px;
  width: 100%;
}

.profile-contents > .container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 30px;
  z-index: 100;
}

.profile-contents > .container-checkbox .checkmark {
  position: absolute;
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  border-radius: 10px;
  top: 5px;
  left: 12px;
}

/* When the checkbox is checked, add a blue background */
.profile-contents > .container-checkbox input:checked ~ .checkmark {
  background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.profile-contents > .container-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.profile-contents > .container-checkbox input:checked ~ .checkmark:after {
  display: block;
  content: "";
  top: 1px;
  left: 1px;
  width: 10px;
  height: 10px;
  background: #fa4242;
  border-radius: 10px;
}

/* Style the checkmark/indicator */
.profile-contents > .container-checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* END GRID2 > 헤더 타이틀  */

.selec-header-title {
  font-weight: 500;
  font-size: 13px;
}
/* GRID3 > 헤더 타이틀 */
#selectTitleName {
  width: 22%;
}
#selectTitleGrade {
  width: 22%;
}
#selectTitleDept {
  width: 42%;
}
#selectTitleDel {
  width: 8%;
}

/* checkbox css */
.all-container-checkbox {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  font-size: 17px;
  margin-top: 6px;
  margin-left: 3px;
}

.all-container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.all-container-checkbox .checkmark {
  position: absolute;
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  border-radius: 10px;
  top: 5px;
  left: 9px;
}

.all-container-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.all-container-checkbox input:checked ~ .checkmark:after {
  display: block;
  content: "";
  top: 1px;
  left: 1px;
  width: 10px;
  height: 10px;
  background: #fa4242;
  border-radius: 10px;
}

.organization-wrap {
  height: calc(100%);
  overflow-y: scroll;
  overflow-x: hidden;
}

.members-wrap {
  width: 96%;
  margin-left: 2%;
  padding-top: 10px;
  height: 70%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.member-item {
  height: 31px;
  margin-top: 5px;
}

/* GRID 3 */

.member-selected-wrap {
  width: 96%;
  height: 70%;
  margin-left: 2%;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-top: 10px;
}

.unselect-wrap {
  margin-top: 10px;
  margin-left: 3%;
  width: 94%;
  height: 50px;
  padding: 8px;
  border-top: 2px solid black;
  border-bottom: 1px solid #d2d2d2;
}

.unselect-title {
  float: left;
  font-size: 12pt;
  font-weight: bold;
  line-height: 30px;
}

.unselect-btn {
  float: right;
  line-height: 30px;
  border: 1px solid black;
  width: 80px;
  text-align: center;
  cursor: pointer;
}
.gg-trash {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs, 1));
  width: 10px;
  height: 12px;
  border: 2px solid transparent;
  box-shadow: 0 0 0 2px, inset -2px 0 0, inset 2px 0 0;
  border-bottom-left-radius: 1px;
  border-bottom-right-radius: 1px;
  margin-top: 4px;
  float: left;
  top: 23px;
  cursor: pointer;
}
.primary {
  background-color: #1867c0 !important;
  border-color: #1867c0 !important;
}

.error {
  background-color: #ff5252 !important;
  border-color: #ff5252 !important;
  margin-top: 15px;
}

.footer-btn > .confirm {
  width: 150px;
  height: 50px;
  background-color: #5cbbf6 !important;
  border-color: #5cbbf6 !important;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin-right: 20px;
  font-size: 13pt;
}

.footer-btn > .cancel {
  width: 150px;
  height: 50px;
  background-color: #607d8b !important;
  border-color: #607d8b !important;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  font-size: 13pt;
}

/* 검색바 */
.seltabwrap .searchbox {
  float: left;
  width: 22%;
}
.seltabwrap .search_top {
  width: 100%;
}
.seltabwrap .search_top .search_input {
  width: 100%;
  padding: 0;
}
.seltabcontent {
  clear: both;
  font-size: 13px;
  height: 370px;
}
/* GRID1 */
.selta_l {
  width: 22%;
  height: 100%;
  border: 1px solid #989898;
  border-radius: 5px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0;
  margin-right: 3%;
  float: left;
}

/* GRID2, 3 */
.grid-title {
  width: 100%;
  height: 15%;
  font-size: 12px;
  position: relative;
  top: 0;
  left: 0;
}
.grid-title span {
  position: absolute;
  bottom: 15%;
  left: 3%;
}
.p_ad {
  width: 33%;
  height: 100%;
  border: 1px solid #989898;
  border-radius: 5px;
  padding: 0;
  position: relative;
  font-weight: 500;
  float: left;
}

.seltab {
  width: 8%;
  text-align: center;
  margin-top: 13%;
  float: left;
}

.search-input {
  padding-left: 1%;
  width: 22%;
  height: 40px;
  font-size: 10pt;
  border-radius: 5px;
  float: left;
  margin-bottom: 15px;
}

.orga-search-btn {
  float: left;
  margin-left: 5px;
  width: 80px;
  padding: 0;
  height: 40px;
  margin-left: 10px;
}

.search_active {
  background: #1757a1;
}

.btnArea {
  display: flex;
  justify-content: end;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}


#organizationChart .dialog-container {
    height: 100%;
  }

  .orga-container {
    margin: 0 20px;
    margin-bottom: 20px;
  }

  .orga-step1 {
    border: 1px solid #dddddd;
    width: 45%;
    height: 100%;
    border-radius: 5px;
    padding: 10px;
    overflow: auto;
    max-height: 300px;
  }

  .orga-step2 {
    width: 55%;
    margin-left: 20px;
    max-height: 300px;
  }

  .orga-search_area {
    margin: 10px 20px;
  }
  .orga-step3 {
    margin: 10px 20px;
  }

  .orga-selected-member-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow: auto;
    max-height: 200px;
  }
  .orga-selected-member {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    margin: 15px;
  }

  .popup_tel_wrap {
    min-width: auto;
    font-size: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/TbOrganizationChartDialog.vue